export default {
  clientes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Pendências de IPS/KYC por cliente + flag do escritório. Fonte da trava de
  // entrada de contrato (US-6) — cobre TODOS os clientes visíveis, não só os
  // que têm linha em compliance_clientes (que é o que `clientes` acima traz).
  pendenciasIpsKyc: {
    loading: false,
    lastUpdate: null,
    data: { exige_ips_kyc: false, clientes: [] },
  },
  config: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  signers: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  ips: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  forms: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  formsAnswer: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  questions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  formClient: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  ipsQuestions: {
    data: [],
  },
  kitDocumentos: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  dataAppCliente: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  kycClassification: {
      loading: false,
      lastUpdate: null,
      data: {},
  },
  // {{NEXT}}
}
